<template>
    <div id="course">
        <loadings v-if="loading"></loadings>
        <template v-else>
            <div class="head">
                <i class="back"
                   @click="back()"></i>
                <p class="title">作业详情</p>
                <p class="preview"
                   @click="preview()">作业预览</p>
            </div>
            <div class="rate">
                <div>
                    <h3>{{ecData.unit_score_rate}}</h3>
                    <p>平均分</p>
                </div>
                <div>
                    <h3>{{ecData.good_score_rate}}<span>%</span></h3>
                    <p>优秀率</p>
                </div>
                <div>
                    <h3>{{ecData.pass_score_rate}}<span>%</span></h3>
                    <p>及格率</p>
                </div>
            </div>
            <div class="tab">
                <p :class="{'active':tabtype==1}"
                   @click="tab(1)">按学生查看</p>
                <p :class="{'active':tabtype==2}"
                   @click="tab(2)">试题错误率</p>
                <p :class="{'active':tabtype==3}"
                   @click="tab(3)">知识点掌握率</p>
            </div>
            <stu v-if="tabtype==1"
                 :dept_type="dept_type"
                 :message_id='this.taskId'
                 :score_group='ecData.score_group'
                 :unit_score_rate='ecData.unit_score_rate'
                 :is_correct_user='is_correct_user'
                 :is_not_correct_user='is_not_correct_user'></stu>
            <wrong v-if="tabtype==2"
                   :sid='sid'
                   :message_id='this.taskId'
                   :unit_class_id='this.classId'></wrong>
            <knowledge v-if="tabtype==3"
                       :sid="sid"
                       :message_id='this.taskId'
                       :unit_class_id='this.classId'></knowledge>

            <div class="btm-btn">
                <p @click="share"
                   :class="(taskType!='2022winter'&&taskType!='2023winter'&&taskType!='2024winter'&&taskType!='2023kxjc'&&taskType!='2023jdjc'&&taskType!='2023qzjc' && !hd_type)?'':'dan'">分享报告给家长</p>
                <p @click="handleUrged"
                   v-if="(taskType!='2022winter'&&taskType!='2023winter'&&taskType!='2024winter'&&taskType!='2023kxjc'&&taskType!='2023jdjc'&&taskType!='2023qzjc'&& !hd_type)"
                   :class="is_not_correct_user.length?'':'gray'">催促作业</p>
            </div>

            <div id="layui-m-layer"
                 class="layui-m-layer layui-m-layer0"
                 v-if='showUrgeLay'>
                <div class="layui-m-layershade"></div>
                <div class="layui-m-layermain">
                    <div class="layui-m-layersection">
                        <div class="layui-m-layerchild  layui-m-anim-scale">
                            <div class="title_container">
                                催促作业
                            </div>
                            <div class="urge-con">
                                <p class="tips">短信接收对象：</p>
                                <p class="gray">未完成本次作业的家长</p>
                                <p class="tips">短信内容：</p>
                                <textarea class="textar"
                                          ref="textar"
                                          v-model='information'>
                                    </textarea>
                            </div>

                            <div class="layui-m-layerbtn">
                                <span @click="handleSureSend">确定发送</span>
                                <span @click="handleCancel">取消</span>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </template>
    </div>
</template>

<script>
import * as echarts from 'echarts';
import loadings from "COMPONENTS/base/loadingS.vue";
import knowledge from "./module/course_knowledge.vue";
import stu from "./module/course_stu.vue";
import wrong from "./module/course_wrong.vue";
export default {
    components: {
        loadings,
        stu,
        knowledge,
        wrong
    },

    data () {
        return {
            inApp: localStorage.getItem("search") && Number(JSON.parse(localStorage.getItem("search")).platform),
            title: decodeURIComponent(this.$route.query.title),
            loading: true,
            status: 0,
            tabtype: this.$store.state.personaLearning.tabtype,
            sid: Number(this.$route.query.sid),
            taskId: this.$route.query.taskId,
            classId: this.$route.query.classId,
            taskType: this.$route.query.taskType,
            testType: this.$route.query.testType,
            dept_type: this.$route.query.dept_type || 0,//1:小学，2：初中
            hd_type: this.$route.query.hd_type || 0,
            stuData: {},//按学生查看数据
            fromPath: '',
            fromData: {},
            ecData: {},
            is_not_correct_user: [],
            is_correct_user: [],
            uerToken: localStorage.getItem("Tbkt-Token"),
            taskDate: "",
            login_url: "",
            showUrgeLay: false,
            information: '',
            type: 5,//  type 1 催促未做完 2 催促个性化学习 3 催促错题订正
            urge_end_date: '', //作业结束时间
            is_not_correct_user_ids: [],//未完成作业的学生ID,

        }
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            // 通过 `vm` 访问组件实例,将值传入fromPath
            vm.fromPath = from.path;
            vm.fromData = from.query;
        })
    },
    computed: {
        fromChild () {
            let formC = false;
            if (this.fromPath.indexOf('task/stuDetail') >= 0 || this.fromPath.indexOf('task/taskDetail') >= 0 || this.fromPath.indexOf('task/knowledgDetail') >= 0) {
                formC = true;
            }
            return formC;
        },
    },
    created () {
        this.getClassData()
    },
    mounted () {

    },
    methods: {
        preview () { //作业预览
            if (this.sid == 21 || this.sid == 22) {
                if (this.taskType == '2022winter' || this.taskType == '2023winter' || this.taskType == '2024winter') {
                    this.$router.push("/preview/task/" + this.sid + "/" + this.taskId + "/" + this.taskType)
                } else if (this.hd_type) {
                    this.$router.push("/preview/task/" + this.sid + "/" + this.taskId + "?hd_type=" + this.hd_type)
                } else {
                    this.$router.push("/preview/task/" + this.sid + "/" + this.taskId + "/" + this.testType)
                }
            }
            if (this.sid == 51) {//语文
                let taskType = this.taskType,
                    testType = this.testType;
                if (taskType == 2 && testType == 4) {
                    this.$router.push("/chinese/inspect/preview/words/" + this.taskId + "?taskType=" + taskType)
                } else if (taskType == 4) {
                    this.$router.push("/chinese/inspect/outread/preview?reid=" + this.reid)
                } else if (this.taskType == '2022winter' || this.taskType == '2023winter' || this.taskType == '2024winter') {
                    this.$router.push("/chinese/inspect/preview/task/" + this.taskId + "/" + this.taskType)
                } else if (this.hd_type) {
                    this.$router.push("/chinese/inspect/preview/task/" + this.taskId + "?hd_type=" + this.hd_type)
                } else {
                    this.$router.push("/chinese/inspect/preview/task/" + this.taskId + "/" + this.testType)
                }

            }
        },



        tab (type) {
            this.tabtype = type;
            this.$store.commit('setTabtype', type)
        },
        getClassData () {
            let data = {}, url = "";
            //2022下期中
            if (this.testType == "qz") {
                data = {
                    "paper_id": this.taskId,
                    "sid": this.sid,
                    "unit_class_id": this.classId
                }
                url = API_URL_HD_API + "/qz2022/tea/paper_detail";

            } else if (this.taskType == "2022winter") {
                url = API_URL_HD_API + "/winter2022/tea/paper_detail";
                data = {
                    sid: this.sid,
                    paper_id: this.taskId,
                    unit_class_id: this.classId,
                }
            } else if (this.taskType == "2023winter" || this.taskType == "2024winter") {
                url = API_URL_HD_API + "/winter2023/tea/paper_detail";
                data = {
                    sid: this.sid,
                    paper_id: this.taskId,
                    unit_class_id: this.classId,
                }
            }
            //2022下期末
            else if (this.testType == "qm") {
                data = {
                    "paper_id": this.taskId,
                    "sid": this.sid,
                    "unit_class_id": this.classId
                }
                url = API_URL_HD_API + "/qm2022_down/tea/paper_detail";
            }
            //2023上开学检测
            else if (this.testType == "2023kxjc") {
                data = {
                    "paper_id": this.taskId,
                    "sid": this.sid,
                    "unit_class_id": this.classId
                }
                url = API_URL_HD_API + "/kxjc2023/tea/paper_detail";
            }
            //2023上阶段检测
            else if (this.testType == "2023jdjc") {
                data = {
                    "paper_id": this.taskId,
                    "sid": this.sid,
                    "unit_class_id": this.classId,
                    "hd_type": 5,
                }
                url = API_URL_HD_API + "/common/tea/paper_detail";
            }
            //2023上期中检测
            else if (this.hd_type) {
                data = {
                    "paper_id": this.taskId,
                    "sid": this.sid,
                    "unit_class_id": this.classId,
                    "hd_type": this.hd_type,
                }
                url = API_URL_HD_API + "/common/tea/paper_detail";
            }
            else if (!this.hd_type) {

                data = {
                    "message_id": this.taskId,
                    "unit_class_id": this.classId
                }
                if (this.sid == 51) {
                    url = API_URL_TASK_API + '/chinese/check/special/task_detail/';
                }
                else if (this.sid == 21) {
                    url = API_URL_TASK_API + '/maths/check/special/task_detail/'
                }
            }
            this.$http.post(url, data).then(res => {
                if (res.data.response == 'ok') {
                    this.loading = false;
                    this.ecData = res.data.data;
                    this.is_not_correct_user = res.data.data.is_not_correct_user;
                    this.is_correct_user = res.data.data.is_correct_user;
                    this.taskDate = res.data.data.task_date;
                    this.urge_end_date = res.data.data.end_date;
                    this.is_not_correct_user_ids = res.data.data.is_not_correct_user_ids;
                    if (this.taskType == "qz") this.login_url = res.data.data.wap_url;
                }
            })
        },


        share () {
            let that = this
            if (this.hd_type) {
                this.taskDate = ''
            }

            let subject = this.sid == 21 ? '数学' : this.sid == 51 ? '语文' : ''
            let className = decodeURIComponent(this.$route.query.className)
            //非活动类型，hd_type=0,url里不传参
            let url = `${VUE_URL_HD}/#/personaLearning/share?sid=${this.sid}&taskId=${this.taskId}&classId=${this.classId}&className=${encodeURIComponent(className)}`;
            if (this.hd_type > 0) {
                url = `${VUE_URL_HD}/#/personaLearning/share?sid=${this.sid}&taskId=${this.taskId}&classId=${this.classId}&hd_type=${this.hd_type}&className=${encodeURIComponent(className)}`;
            }
            if (this.inApp) {
                //判断学科
                let zhcpText = (this.sid == 21 && this.testType == 15) || (this.sid == 51 && this.testType == 17) ? "学情检测" : "";
                let title = `${className}${this.taskDate}${subject}${zhcpText}学情报告`;
                if (this.testType == "qz") {
                    title = `${className}${subject}课堂练习学情报告`;
                } else if (this.taskType == "2022winter") {
                    title = `${className}${subject}寒假作业学情报告`;
                } else if (this.taskType == "2023winter") {
                    title = `${className}${subject}寒假作业学情报告`;
                    url = url + '&taskType=2023winter';
                } else if (this.taskType == "2024winter") {
                    title = `${className}${subject}寒假作业学情报告`;
                    url = url + '&taskType=2024winter';
                } else if (this.taskType == "2023kxjc") {
                    title = `${className}${subject}新学期学业评价报告`;
                } else if (this.taskType == "2023jdjc") {
                    title = `${className}${subject}阶段检测学情报告`;
                } else if (this.hd_type == "6") {
                    title = `${className}${subject}阶段性测试学情报告`;
                } else if (this.testType == "qm") {
                    title = `${className}${subject}学业质量评价学情报告`;
                } else if (this.hd_type == 7) {
                    title = `${className}${subject}期末综合测评学情报告`;
                } else if (this.hd_type == 9) {
                    title = `${className}${subject}期中检测学情报告`;
                } else if (this.hd_type == 10) {
                    title = `${className}${subject}期末检测学情报告`;
                } else if (this.hd_type == 12) {
                    title = `${className}${subject}领跑新学期学情报告`;
                } else if (this.hd_type == 13) {
                    title = `${className}${subject}阶段性检测学情报告`;
                }
                let content = this.hd_type == 7 ? "点击查看教师点评" : "点击查看详情";
                this.appFunction("ys_share", `${title},${content},${url}`);
            } else {
                let coptText = `${className}${this.taskDate}${subject}学情报告已生成，点击下方链接查看：${url}`
                if ((this.sid == 21 && this.testType == 15) || (this.sid == 51 && this.testType == 17)) {
                    coptText = `${className}${subject}学情检测学情报告已生成，点击下方链接查看：${url}`;
                } else if (this.testType == "qz") {
                    coptText = `${className}${subject}课堂练习学情报告已生成，点击下方链接查看：${url}`;
                } else if (this.taskType == "2022winter") {
                    coptText = `${className}${subject}寒假作业学情报告已生成，点击下方链接查看：${url}`;
                } else if (this.taskType == "2023winter") {
                    this.$http.post(API_URL_SORT_API + '/create_sort/', {
                        url: url + '&taskType=2023winter',
                        sort_type: 2
                    }).then((res) => {
                        if (res.data.response === 'ok') {
                            coptText = `${className}${subject}寒假作业学情报告，点击链接查看详情，链接：${res.data.data.short_url}`;
                            layer.alert('将链接分享到对应的班级群，点击链接即可查看班级作业报告。', 'tea', function (index) {
                                layer.close(index)
                                that.copyText(coptText);
                            }, '分享链接复制成功')
                        }
                    })
                } else if (this.taskType == "2024winter") {
                    this.$http.post(API_URL_SORT_API + '/create_sort/', {
                        url: url + '&taskType=2024winter',
                        sort_type: 2
                    }).then((res) => {
                        if (res.data.response === 'ok') {
                            coptText = `${className}${subject}寒假作业学情报告，点击链接查看详情，链接：${res.data.data.short_url}`;
                            layer.alert('将链接分享到对应的班级群，点击链接即可查看班级作业报告。', 'tea', function (index) {
                                layer.close(index)
                                that.copyText(coptText);
                            }, '分享链接复制成功')
                        }
                    })
                } else if (this.testType == "qm") {
                    coptText = `${className}${subject}学业质量评价学情报告已生成，点击下方链接查看：${url}`;
                } else if (this.testType == "2023kxjc") {
                    coptText = `${className}${subject}新学期学业评价报告已生成，点击下方链接查看：${url}`;
                } else if (this.testType == "2023jdjc") {
                    coptText = `${className}${subject}阶段检测学情报告已生成，点击下方链接查看：${url}`;
                } else if (this.hd_type == "6") {
                    coptText = `${className}${subject}阶段性测试学情报告已生成，点击下方链接查看：${url}`;
                }
                if (this.hd_type >= 7) {
                    this.$http.post(API_URL_SORT_API + '/create_sort/', {
                        url: url,
                        sort_type: 2
                    }).then((res) => {
                        if (res.data.response === 'ok') {
                            if (this.hd_type == 7) {
                                //2023上期末检测分享需要短链
                                coptText = `${className}${subject}期末综合测评学情报告已生成，点击下方链接查看老师点评：${res.data.data.short_url}`
                            } else if (this.hd_type == 8) {
                                //2023上期末检测分享需要短链
                                coptText = `${className}${subject}期末考试卷学情报告，点击链接查看老师点评：${res.data.data.short_url}`
                            }
                            else if (this.hd_type == 9) {
                                //2023下期中检测分享需要短链
                                coptText = `${className}${subject}期中检测学情报告已生成，点击下方链接查看：${res.data.data.short_url}`
                            }
                            else if (this.hd_type == 10) {
                                //2023下期中检测分享需要短链
                                coptText = `${className}${subject}期末检测学情报告，点击链接查看教师点评，链接：${res.data.data.short_url}`
                            }
                            else if (this.hd_type == 12) {
                                //2023下期中检测分享需要短链
                                coptText = `${className}${subject}领跑新学期学情报告，点击链接查看教师点评，链接：${res.data.data.short_url}`
                            }
                            else if (this.hd_type == 13) {
                                //2024上期中检测分享需要短链
                                coptText = `${className}${subject}阶段性检测学情报告，点击链接查看教师点评，链接：${res.data.data.short_url}`
                            }
                            layer.alert('将链接分享到对应的班级群，点击链接即可查看班级作业报告。', 'tea', function (index) {
                                layer.close(index)
                                that.copyText(coptText);
                            }, '分享链接复制成功')
                        }
                    })
                }
            }

        },

        /**获取分享短链地址 */
        getShortUrl (url) {
            this.$http.post(API_URL_SORT_API + '/create_sort/', {
                url: url,
                sort_type: 2
            }).then((res) => {
                if (res.data.response === 'ok') {
                    return res.data.data.short_url
                }
            })
        },
        copyText (text) {
            const input = document.createElement('input');
            input.setAttribute('readonly', 'readonly');
            input.setAttribute('value', text);
            document.body.appendChild(input);
            input.setSelectionRange(0, 9999);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
        },
        //催促作业
        handleUrged () {
            if (!this.is_not_correct_user.length) {
                layer.tips("所有学生都已完成作业");
                return
            }
            let url = `${WAP_URL}/qr/special?is_sum=1&is_share=1&sid=${this.sid}&unit_ids=${this.classId}`
            this.$http.post(API_URL_SORT_API + '/create_sort/', {
                url: url,
                sort_type: 1
            }).then((res) => {
                if (res.data.response === 'ok') {
                    this.showUrgeLay = true
                    this.information = `家长您好，孩子有学习内容尚未完成，截止至：${this.urge_end_date}，请点击${res.data.data.short_url}查看内容或关注“精准教学系统”微信公众号完成。【${JSON.parse(localStorage.getItem('info')).real_name}老师】`
                }
            })


        },
        //取消
        handleCancel () {
            this.showUrgeLay = false
        },
        //确定发送短信
        handleSureSend () {
            let params = {
                message_id: this.taskId,
                unit_class_id: this.classId,
                sid: this.sid,
                stu_user_id: this.is_not_correct_user_ids,
                content: this.information,
                type: this.type,
                open_type: 0,
                is_edit: 1,
                sms_id: 16,
                place_id: this.sid == 21 ? 30 : this.sid == 51 ? 26 : 0,//配置平台发送短信配置参数
            }
            this.$http.post(API_URL_TASK_API + '/public/task/urge', params).then(res => {
                if (res.data.response == 'ok') {
                    layer.tips("短信发送成功");
                    this.showUrgeLay = false
                } else {
                    layer.tips("短信发送失败");
                }

            })
        },
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.head {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100vw;
    height: 96px / $ppr;
    background: #5e89ef;

    .back {
        position: absolute;
        top: 0;
        left: 0;
        width: 76px / $ppr;
        height: 96px / $ppr;
        background: url(./img/choose_back.png) no-repeat center;
        background-size: 18px / $ppr 34px / $ppr;
    }

    .title {
        width: 100%;
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        font-size: 34px / $ppr;
        color: #fff;
        text-align: center;
    }

    .preview {
        position: absolute;
        top: 0;
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        right: 24px / $ppr;
        z-index: 10;
        font-size: 30px / $ppr;
        color: #fff;
    }
}
#course {
    padding-bottom: 150px / $ppr;
    width: 100%;
    height: 100vh;
    overflow-x: hidden;
    padding-top: 136px / $ppr;
    box-sizing: border-box;
}
.list {
    // width:660px/$ppr;
    width: 100%;
    margin: 0 auto;
    height: 120px / $ppr;
    position: relative;
    &::before {
        display: block;
        width: 30px / $ppr;
        height: 120px / $ppr;
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        z-index: 5;
        background-image: linear-gradient(
            to left,
            rgba(247, 248, 249, 1) 0%,
            rgba(247, 248, 249, 0) 100%
        );
    }
    &::after {
        display: block;
        width: 30px / $ppr;
        height: 120px / $ppr;
        content: "";
        position: absolute;
        right: 0;
        top: 0;
        z-index: 5;
        background-image: linear-gradient(
            to left,
            rgba(247, 248, 249, 0) 0%,
            rgba(247, 248, 249, 1) 100%
        );
    }
    .list_warp {
        position: relative;
        overflow-x: auto;
        height: 60px / $ppr;
        padding: 30px / $ppr 0;
        overflow-y: hidden;
        &::-webkit-scrollbar {
            display: none;
        }
        .list_item {
            position: absolute;
            top: 30px / $ppr;
            left: 30px / $ppr;
            overflow-x: auto;
            white-space: nowrap;
            display: flex;
            height: 60px / $ppr;
            span {
                display: block;
                // float: left;
                width: 120px / $ppr;
                height: 60px / $ppr;
                line-height: 60px / $ppr;
                background: #fff;
                border-radius: 8px / $ppr;
                margin-right: 24px / $ppr;
                text-align: center;
                color: #7b84a0;
                font-size: 26px / $ppr;
                &.active {
                    background: #0f8fff;
                    color: #fff;
                }
            }
        }
    }
}
.box {
    width: 600px / $ppr;
    margin: 0 auto 30px / $ppr;
    background: #fff;
    padding: 25px / $ppr 30px / $ppr 46px / $ppr;
    border-radius: 16px / $ppr;
    h3 {
        font-size: 30px / $ppr;
        margin-bottom: 24px / $ppr;
        line-height: 56px / $ppr;
        position: relative;
        padding-left: 48px / $ppr;
        font-weight: bold;
        i {
            position: absolute;
            left: 0;
            top: 50%;
            margin-top: -17px / $ppr;
            display: block;
            width: 32px / $ppr;
            height: 32px / $ppr;
            background: url("./img/icon03.png") 0 0 no-repeat;
            background-size: 100% 100%;
        }
    }
}
.rate {
    width: 690px / $ppr;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    div {
        background-image: linear-gradient(#fff, #f7f8f9);
        width: 220px / $ppr;
        text-align: center;
        padding: 30px / $ppr 0 50px / $ppr;
        &:nth-child(1) {
            h3 {
                color: #3c7cfb;
            }
        }
        &:nth-child(2) {
            h3 {
                color: #4ecb39;
            }
        }
        &:nth-child(3) {
            h3 {
                color: #ffaf5a;
            }
        }
        h3 {
            line-height: 66px / $ppr;
            font-size: 56px / $ppr;
            font-weight: bold;
            span {
                font-size: 32px / $ppr;
                font-weight: normal;
            }
        }
        p {
            font-size: 24px / $ppr;
            color: #999;
        }
    }
}
.tab {
    width: 604px / $ppr;
    margin: 25px / $ppr auto 0;
    border: 1px / $ppr solid #5e89ef;
    display: flex;
    justify-content: space-between;
    border-radius: 28px / $ppr;
    overflow: hidden;
    background: #fff;
    // width: 604px / $ppr;
    // height: 54px / $ppr;
    // margin: 25px / $ppr auto 0;
    // border: 1px solid #5e89ef;
    // display: flex;
    // justify-content: space-between;
    // border-radius: 28px / $ppr;
    p {
        flex: 0 0 33.33333%;
        line-height: 56px / $ppr;
        font-size: 28px / $ppr;
        color: #5e89ef;
        text-align: center;
        box-sizing: border-box;

        &:nth-child(2) {
            border-left: 1px / $ppr solid #5e89ef;
            border-right: 1px / $ppr solid #5e89ef;
        }

        &.active {
            background: #5e89ef;
            color: #ffffff;
        }
    }
}
.white_bg {
    background: #fff;
}
.dighol_span_number {
}
.scoreChartWarp {
    width: 600px / $ppr;
    margin: 0 auto;
    overflow-x: auto;
}
.btm-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 20px / $ppr 32px / $ppr;
    background: #fff;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    p {
        flex: 0 0 48%;
        background: #5e89ef;
        color: #fff;
        font-size: 30px / $ppr;
        line-height: 80px / $ppr;
        border-radius: 80px / $ppr;
        text-align: center;
    }
    .gray {
        background: #eaeaea;
        color: #666;
    }
    .dan {
        flex: 1;
    }
}

.layui-m-layer .layui-m-layerchild {
    width: 90% !important;
    max-width: 620px !important;
    border-radius: 0.5rem;
    overflow: hidden;
}
.title_container {
    font-size: 34px / $ppr;
    color: #333;
    text-align: center;
    padding: 40px / $ppr 0;
    font-weight: bold;
}
.urge-con {
    padding: 0 40px / $ppr;
    line-height: 1;
    .tips {
        color: #999;
        font-size: 28px / $ppr;
        padding-bottom: 24px / $ppr;
    }
    .gray {
        font-size: 28px / $ppr;
        color: #333;
        padding-bottom: 60px / $ppr;
    }

    .textar {
        width: 100%;
        font-size: 27px / $ppr;
        color: #333;
        background: #f2f2f2;
        height: 270px / $ppr;
        padding: 32px / $ppr 32px / $ppr 20px / $ppr;
        border: 0;
        box-sizing: border-box;
        line-height: 1.6;
        font-family: "微软雅黑";
    }
}
.layui-m-layerbtn {
    border-top: 0;
    display: flex;
    justify-content: space-between;
    padding: 40px / $ppr;
    box-sizing: border-box;
    height: auto;
    span {
        flex: 0 0 48%;
        background: #5e89ef;
        color: #fff;
        font-size: 30px / $ppr;
        line-height: 70px / $ppr;
        border-radius: 70px / $ppr;
        text-align: center;
        &:last-child {
            background: #eaeaea;
            color: #333;
        }
    }
}
</style>